import { FDCConcurrenceLevelSideEffect } from 'shared'
import CIMSFormItem from 'components/CIMSFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import { HelpMessage } from 'utils/constants'
import { DefaultOptionType } from 'components/CIMSSelect/types'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import CIMSSelect from 'components/CIMSSelect'
const Help = HelpMessage.FieldDesignChanges.Concurrences.Levels

const CreateEditModalBody: React.FC<{
  approvalGroups: DefaultOptionType[]
}> = ({ approvalGroups }) => {
  const sideEffects = useOptions({
    items: FDCConcurrenceLevelSideEffect.values,
    value: 'id',
    label: 'name',
    tooltip: 'description',
    sort: 'name',
  })
  return (
    <>
      <NameFormItem help={Help.Name} />
      <DescriptionFormItem entityName="Concurrence Level" />
      <CIMSFormItem
        name="approvalGroupIds"
        label="Approval Groups"
        help={Help.ApprovalGroups}
      >
        <CIMSSelect options={approvalGroups} multiple simple />
      </CIMSFormItem>
      <CIMSFormItem
        name="sideEffectId"
        label="Side Effect"
        help={Help.SideEffect}
      >
        <CIMSSelect options={sideEffects} simple />
      </CIMSFormItem>
    </>
  )
}

export default CreateEditModalBody
